import React from "react";
import { addOrUpdateBooking } from "../../../../../APIs/Booking/UpdateBooking";
import { useBookingPermissions } from "../../../../../hooks/useBookingPermissions";
import { useDiaryContext } from "../../../../../hooks/useDiaryContext";
import { useNotificationsContext } from "../../../../../hooks/useNotificationsContext";
import { BookableArea } from "../../../../../types/venues";
import FindAreasModal from "../../Sidebar/AddBooking/FindAreas/FindAreasModal";

type EditBookingAreaType = {
  handleClose: () => void;
};

export const EditBookingArea = ({ handleClose }: EditBookingAreaType) => {
  const notificationsContext = useNotificationsContext();
  const bookingContext = useDiaryContext();
  const { userCanManageBooking } = useBookingPermissions();

  if (!bookingContext.selectedBooking || !userCanManageBooking) {
    return null;
  }

  const saveAreaChange = async (selectedAreas: BookableArea[]) => {
    if (!bookingContext.selectedBooking) {
      return;
    }
    const additionalAssignedAreas = [...selectedAreas];
    additionalAssignedAreas.shift();
    const response = await addOrUpdateBooking({
      booking: {
        ...bookingContext.selectedBooking,
        assignedAreas: selectedAreas.map((area) => ({
          id: area.id as unknown as object
        })),
        additionalAssignedAreas: additionalAssignedAreas.map((area) => area.id)
      },
      diaryContext: bookingContext
    });

    notificationsContext.addNotification({
      heading:
        !response || response?.unsaved ? "Update pending" : "Booking updated",
      autoClose: 4000,
      toastType: "information"
    });
  };

  return (
    <FindAreasModal
      open={true}
      booking={bookingContext.selectedBooking}
      selectedAreas={
        bookingContext.selectedBooking.assignedAreas?.map((area) => ({
          id: `${area.id}`
        })) ?? []
      }
      setSelectedAreas={saveAreaChange}
      handleClose={handleClose}
    />
  );
};
